
import '../sass/_icons.scss';
import { IconContext } from "react-icons";

function Icon({children, classname= '', click}) {
    let classn = 'icon ' + classname;

    return (
        <IconContext.Provider value={{ color: "blue"}}>
            <div onClick={click}  className={classn} >
                {children}
            </div>
        </IconContext.Provider>

        
    )
}

export default Icon